import { isInViewport, debounce } from '../helpers';

//stats counter animation
function animateValue( obj, start, beforeChars, end, afterChars, duration ) {
	let startTimestamp = null;
	const step = function( timestamp ) {
		if ( ! startTimestamp ) {
			startTimestamp = timestamp;
		}
		const progress = Math.min( ( timestamp - startTimestamp ) / duration, 1 );
		obj.innerHTML = beforeChars + Math.floor( progress * ( end - start ) + start ) + afterChars;
		if ( progress < 1 ) {
			window.requestAnimationFrame( step );
		}
	};
	window.requestAnimationFrame( step );
}

export function runStatsCounter() {
	let counter = 0;
	function runStatsAnimation() {
		if ( counter > 0 ) {
			return;
		}
		const objects = document.querySelectorAll( '.section-stats-counter .increase h2' );
		for ( let i = 0; i < objects.length; i++ ) {
			const obj = objects[ i ];
			const objNumber = obj.textContent.replace( /\D/g, '' );
			const objBeforeChars = obj.textContent.match( /[^0-9]*/ );
			const objAfterChars = obj.textContent.match( /[^0-9]*$/ );
			const visible = isInViewport( obj );
			if ( visible ) {
				animateValue( obj, 0, objBeforeChars, objNumber, objAfterChars, 2250 );
				counter++;
			}
		}
	}
	window.addEventListener( 'scroll', debounce( runStatsAnimation, 150 ) );
}
